import { ModalConfig } from '@shared/interfaces/modal/modal-config';
import { DefaultModalComponent } from '@shared/modals/default/default-modal/default-modal.component';

/**
 * Default configuration object for a modal.
 *
 * This object defines the default settings for a modal, including the component to render,
 * title, type, and the list of actions available within the modal.
 *
 * @type {ModalConfig}
 */
export const modalConfigDefault: ModalConfig = {
  component: DefaultModalComponent,
  title: 'modal.blank.title',
  actions: [
    { type: 'primary', label: 'system.button.save', method: 'submit' },
    { type: 'secondary', label: 'system.button.cancel', closeOnClick: true },
  ]
}
